import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { waitForAuthStateReady } from '../../../Auth/utilities/authUtils';

import BlogListPage from '../BlogListPage.jsx';


import {
  deletePortfolio,
  loadPortfolio,
  loadUserPortfolios,
  portfolioExists,
  renamePortfolio,
  savePortfolio
} from '../../utilities/Portfolios/draftPortfolioUtils';

const DraftListPage = () => {

    const navigate = useNavigate();

    const [userId, setUserId] = useState(null);

    useEffect(() => {
      const fetchUserId = async () => {
        const uid = await waitForAuthStateReady();
        if (!uid) {
          const redirectPath = encodeURIComponent(`${window.location.pathname}${window.location.search}${window.location.hash}`);
          navigate(`/login?redirectPath=${redirectPath}`);
          return;
        }

        setUserId(uid);
      };

      void fetchUserId();
    }, [navigate]);

    return(
        <BlogListPage 
        type={"Draft"}
        path={`/${userId}/drafts`}
        userId={userId}
        loadPortfolio={loadPortfolio} 
        loadPortfolios={loadUserPortfolios} 
        deletePortfolio={deletePortfolio}
        portfolioExists={portfolioExists}
        savePortfolio={savePortfolio}
        renamePortfolio={renamePortfolio}
        allowedActions={['Edit', 'Publish', 'View', 'Copy', 'Delete', 'Rename']}
        />
    )
}

export default DraftListPage;